import type { CriterionKey } from "../duo-rubric";
import type { TurnScore } from "@a2/core";

/**
 * Mirrors the report API's Totals shape — kept in the SPA so the report
 * components can import a stable client-side type without reaching into
 * the server source.
 */
export type Totals = {
  total: number;
  max: number;
  percentage: number;
  passed: boolean;
  perCriterion: Record<CriterionKey, number>;
  perCriterionMax: Record<CriterionKey, number>;
};

export function formatBadge(score: TurnScore): string {
  const total = score.ad + score.wo + score.gr + score.vl + score.helderheid + score.uit;
  let badge = `🎯 **${total} / 12**  ·  ad ${score.ad}/3 · wo ${score.wo}/2 · gr ${score.gr}/2 · vl ${score.vl}/2 · hel ${score.helderheid}/1 · uit ${score.uit}/2`;
  if (score.uitNotes) badge += `\n\n*uitspraak: ${score.uitNotes}*`;
  return badge;
}
